import { Provider } from '@angular/core';
import { TokenService } from '../authentication/parameters';
import { TokenService as OriginalTokenService } from 'projects/authentication/src/app/services/parameters';
import { CacheService } from 'projects/common/src/app/services';

/**
 * Provee la contrucción de una instancia del servicio que se encargará de mantener
 * el parámetro de token de sesión
 *
 * TokenService
 */
const tokenServiceFactory = (cacheService) => {
  return new OriginalTokenService(cacheService);
};

/**
 * Provider que define el alias para la utilización del servicio que se encargará
 * de la comunicación remota y que implementará el método tokenServiceFactory
 * para la creación
 */
export const tokenServiceProvider: Provider = {
  provide: TokenService,
  useFactory: tokenServiceFactory,
  deps: [CacheService]
};
